import { phiTrack } from './phiTrack';
import { recordFunnelEvent } from './siteStats';

/**
 * Referral funnel events (docs/REFERRAL-ANALYTICS.md). No PII: never an email, uid or referral
 * code, only booleans, an allowlisted reason/kind/sku and whole-dollar amounts. Each event fires
 * at most once per page view (per path and kind) so re-renders and token refreshes do not repeat it.
 */
const fired = new Set();
const SKU = /^[a-z0-9-]{1,40}$/;
const REASONS = ['attributed', 'not_attributed', 'error'];

function once(eventName, discriminator, props) {
  const path = typeof window !== 'undefined' ? window.location.pathname : '';
  const key = `${eventName}|${path}|${discriminator}`;
  if (fired.has(key)) return false;
  fired.add(key);
  phiTrack(eventName, props);
  return true;
}
const kindOf = kind => (kind === 'credit' ? 'credit' : 'discount');
const dollars = v => (Number.isFinite(Number(v)) ? Math.max(0, Math.min(10000, Math.round(Number(v)))) : 0);

/** A link carrying ?ref= was opened; hasCode = it resolved to a well-formed code or username. */
export function trackReferralLanding({ hasCode } = {}) {
  try { if (!new URLSearchParams(window.location.search).has('ref')) return false; } catch { return false; }
  return once('referral_landing', '', { hasCode: Boolean(hasCode) });
}

export function trackReferralClaimResult({ attributed, reason } = {}) {
  const r = REASONS.includes(reason) ? reason : attributed ? 'attributed' : 'not_attributed';
  return once('referral_claim_result', '', { attributed: Boolean(attributed), reason: r });
}

export function trackReferralQuoteShown({ kind, amountUsd } = {}) {
  return once('referral_quote_shown', kindOf(kind), { kind: kindOf(kind), amountUsd: dollars(amountUsd) });
}

export function trackReferralCheckoutStarted({ kind, sku } = {}) {
  return once('referral_checkout_started', kindOf(kind), { kind: kindOf(kind), sku: SKU.test(String(sku || '')) ? sku : 'other' });
}

export function trackReferralCardView() {
  return once('referral_card_view', '', {});
}

const NAV_SOURCES = ['button', 'menu'];
const count = (name) => {
  try { Promise.resolve(recordFunnelEvent(name)).catch(() => {}); } catch { /* non-blocking */ }
};

/**
 * Firestore daily counter (siteStats/{UTC day} funnel.referral_nav_open + __button/__menu/__other)
 * for each navbar "Get $10"/"Refer" panel open. Anonymous, no dedupe: every open counts.
 */
export function recordReferralNavOpen(source) {
  const s = NAV_SOURCES.includes(source) ? source : 'other';
  count('referral_nav_open');
  count(`referral_nav_open__${s}`);
}

/** Tests only. */
export function resetReferralTracking() {
  fired.clear();
}
